import React, { useCallback } from 'react';
import { LazyCopilotControl } from '@/components/composite/CopilotControl';
import { BottomPageControlsWrapper } from '@/components/layout/BottomPageControlsWrapper';
import { useCurrentOrganization } from '@/core/hooks/useCurrentOrganization';
import type { QueryCopilotResponseData } from '@/pages/api/map-events/query-copilot.types';
import { useFiltersContext } from '../../context/FiltersContextProvider';
import { useMapEventsContext } from '../../context/MapEventsContextProvider';
import { useMapCopilotCommunication } from './hooks/useMapCopilotCommunication';

export const MapCopilotControl = () => {
  const { organizationModel } = useCurrentOrganization();
  const { setQueryIncidentsData } = useMapEventsContext();

  const { applyFilterQuery, resetFilters } = useFiltersContext();
  const onCopilotDataChange = useCallback((data: QueryCopilotResponseData, query?: string) => {
    setQueryIncidentsData(data.incidents ?? []);
    resetFilters();

    if (query) applyFilterQuery(query);
  }, []);

  const communication = useMapCopilotCommunication({ onDataChange: onCopilotDataChange });

  return organizationModel?.isCopilotAvailable({ type: 'incidents' }) ? (
    <BottomPageControlsWrapper>
      <LazyCopilotControl communication={communication} />
    </BottomPageControlsWrapper>
  ) : null;
};
